import { useQuery } from '@tanstack/react-query';
import { n8nFetch } from '../n8nClient';
import type { ContatoGlobal } from '../types';

interface ContatosFilter {
  q?: string;
  eh_decisor?: boolean;
  limit?: number;
}

export function useContatosGlobal(filter: ContatosFilter = {}) {
  const params = new URLSearchParams();
  if (filter.q) params.set('q', filter.q);
  if (filter.eh_decisor) params.set('eh_decisor', 'true');
  if (filter.limit) params.set('limit', String(filter.limit));
  const qs = params.toString();
  return useQuery({
    queryKey: ['contatos-global', filter],
    queryFn: () => n8nFetch<ContatoGlobal[]>(`/contatos${qs ? `?${qs}` : ''}`),
  });
}
